import { createMultiPanel } from '@tritt/multipanel'
import { allContent } from '@/router'
import { GENERAL_LEDGER } from '@/genleg'
import { INVOICE_VIEW, INVOICE_CREATOR } from '@/invoice'
import { SUBACC_DETAILS } from '@/subaccount'
import { TRANSACTIONS } from '@/transaction'
import { orgSelectionComplete, selectedOrg } from '@/tenants/org.service'
import emitter from '@/services/infrastructure/emitter'
import { ORG_SWITCHED } from '@/types/events'
import { isDark } from '@/theme/theme.service'

/**
 * Creates the MultiPanel plugin with all domain-specific configuration.
 * This is the single place where domain constants are mapped to the panel system.
 *
 * This file intentionally lives outside src/multipanel/ because it is owned by
 * the host application, not the (future) extracted multipanel package.
 */
export const multiPanelPlugin = createMultiPanel({
    routes: allContent,
    defaultRoute: 'Dashboard',
    indexRoute: 'Index',
    dropHandlers: {
        [GENERAL_LEDGER.componentName]: 'Link til hovedbok',
        [INVOICE_VIEW.componentName]: 'Link til faktura',
        [INVOICE_CREATOR.componentName]: 'Link til fakturajournal',
        [SUBACC_DETAILS.componentName]: 'Link til kunde/leverandørkort',
        [TRANSACTIONS.componentName]: 'Link til bilagsjournal',
    },
    authGuard: async () => {
        await orgSelectionComplete
        return !!selectedOrg.value
    },
    onAuthStateChange: (callback) => {
        emitter.on(ORG_SWITCHED, callback)
    },
    isDark: isDark,
})

